'use client';

import { Fragment } from 'react';

import { type EnergyEfficiencyFlagProps } from '@packages/shared/src/ui/EnergyEfficiencyFlag/EnergyEfficiencyFlag';
import { ProductCardV2DatasheetLink, type Datasheet } from './ProductCardV2.DatasheetLink';
import type { EfficiencyFlagOverlay } from '../EfficiencyFlags/components/EfficiencyFlagOverlayDialog/EfficiencyFlagOverlayDialog.client';
import { EfficiencyFlagOverlayDialog } from '../EfficiencyFlags/components/EfficiencyFlagOverlayDialog/EfficiencyFlagOverlayDialog.client';
import { EnergyEfficiencyFlagLocalized } from '../EfficiencyFlags/components/EnergyEfficiencyFlagLocalized/EnergyEfficiencyFlagLocalized.client';

export type ProductCardV2EnergyEfficiencyFlagsProps = {
  flags: Array<
    EnergyEfficiencyFlagProps & {
      overlay?: EfficiencyFlagOverlay;
      datasheet?: Datasheet;
    }
  >;
};

export const ProductCardV2EnergyEfficiencyFlags = ({
  flags,
}: ProductCardV2EnergyEfficiencyFlagsProps) => (
  <div className="grid [grid-template-columns:auto_1fr] items-center gap-1">
    {flags.map(({ datasheet, overlay, ...flagProps }, index) => {
      const componentId = `efficiency-component-${overlay?.title ?? index}`;

      return (
        <Fragment key={overlay?.title ?? index}>
          <EfficiencyFlagOverlayDialog overlay={overlay} aria-describedby={componentId}>
            <EnergyEfficiencyFlagLocalized {...flagProps} />
          </EfficiencyFlagOverlayDialog>

          <div className="flex flex-col">
            {flags.length > 1 && overlay && (
              <span id={componentId} className="text-size-body-xs font-semibold hyphens-auto">
                {overlay.title}
              </span>
            )}
            {datasheet && (
              <ProductCardV2DatasheetLink datasheet={datasheet} ariaDescribedBy={componentId} />
            )}
          </div>
        </Fragment>
      );
    })}
  </div>
);
